// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.IconButton_IconButton__CFcjO,
.IconButton_disabled__HGt7i {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  text-transform: capitalize;
  border-radius: var(--border-radius-full);
  padding: 12px;
  font: var(--body-font-two);
  background-color: var(--white);
  color: var(--black);
  border: 1px solid transparent;
  letter-spacing: 0.3px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2509803922);
}
button.IconButton_IconButton__CFcjO img,
button.IconButton_IconButton__CFcjO svg,
.IconButton_disabled__HGt7i img,
.IconButton_disabled__HGt7i svg {
  width: 20px;
  height: 20px;
}

.IconButton_disabled__HGt7i {
  background-color: #d0d0d0;
  color: #a0a0a0;
  cursor: not-allowed;
}
.IconButton_disabled__HGt7i:hover {
  background-color: #d0d0d0;
  color: #a0a0a0;
}
.IconButton_disabled__HGt7i:active {
  background-color: #d0d0d0;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/iconButton/IconButton.module.scss"],"names":[],"mappings":"AACA;;EAEC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,0BAAA;EACA,wCAAA;EACA,aAAA;EACA,0BAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,qBAAA;EACA,wDAAA;AAAD;AAEC;;;;EAEC,WAAA;EACA,YAAA;AAEF;;AAGA;EACC,yBAAA;EACA,cAAA;EACA,mBAAA;AAAD;AAEC;EACC,yBAAA;EACA,cAAA;AAAF;AAGC;EACC,yBAAA;AADF","sourcesContent":["// Contained variant button\r\nbutton.IconButton,\r\n.disabled {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\tcursor: pointer;\r\n\ttext-transform: capitalize;\r\n\tborder-radius: var(--border-radius-full);\r\n\tpadding: 12px;\r\n\tfont: var(--body-font-two);\r\n\tbackground-color: var(--white);\r\n\tcolor: var(--black);\r\n\tborder: 1px solid transparent;\r\n\tletter-spacing: 0.3px;\r\n\tbox-shadow: 0px 0px 10px 0px #00000040;\r\n\r\n\timg,\r\n\tsvg {\r\n\t\twidth: 20px;\r\n\t\theight: 20px;\r\n\t}\r\n}\r\n\r\n// Disabled state style\r\n.disabled {\r\n\tbackground-color: #d0d0d0;\r\n\tcolor: #a0a0a0;\r\n\tcursor: not-allowed;\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #d0d0d0;\r\n\t\tcolor: #a0a0a0;\r\n\t}\r\n\r\n\t&:active {\r\n\t\tbackground-color: #d0d0d0;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"IconButton": `IconButton_IconButton__CFcjO`,
	"disabled": `IconButton_disabled__HGt7i`
};
export default ___CSS_LOADER_EXPORT___;
